import { render, staticRenderFns } from "./GlbRenderer3D.vue?vue&type=template&id=5f139eda&scoped=true"
import script from "./GlbRenderer3D.vue?vue&type=script&lang=js"
export * from "./GlbRenderer3D.vue?vue&type=script&lang=js"
import style0 from "./GlbRenderer3D.vue?vue&type=style&index=0&id=5f139eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f139eda",
  null
  
)

export default component.exports